import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  name: 'formatarValorMixin',
  methods: {
    formatarValor: function(valor, quant_casas_decimais = 3){
      valor = Biblioteca.valor(valor);

      var formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: quant_casas_decimais,
        maximumFractionDigits: quant_casas_decimais
      });

      return formatter.format(valor);
    },

    strPadraoToNumber(str){
      str = Biblioteca.valor(str);
      return str.toString();
    },

    npz(valor) {
      let valor_npz = Biblioteca.valor(valor);

       if (valor_npz === 0) {
        return '';
      }

      return valor;
    },

    ValorInt: function(str){
      return Biblioteca.valorInt(str);
    },

    Valor: function(str){
      return Biblioteca.valor(str);
    },

    Arredondar(val, casas_decimais = 2){
      return Biblioteca.arredondar(val, casas_decimais);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formatarValorMixin.js